// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__35UKO","select":"Header_select__Td-rx","clinic":"Header_clinic__3dLjE"};